<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: [CW-VP-DIM] cw.CwCaseTypeDefault object component — Set-Kopf (data widget + edit toggle),
    the READ-ONLY Vorbelegungs-Vorschau of the alias-keyed fieldValuesJson, and the Bausteine child
    table. Guarded by @if (initialized && dto); stacked vertically so it fits the right drawer
    (uiMode 'side') and full mode alike.
-->
@if (initialized && dto) {
    <div class="cw-case-type-default-object flex flex-column gap-4 p-3">

        <!-- Set-Kopf: Stammdaten der Vorbelegung -->
        <div>
            <div class="flex align-items-center justify-content-between mb-2">
                <span class="text-lg font-medium">Vorbelegung-Stammdaten</span>
                <p-button
                        [label]="editDefault ? 'Ansicht' : 'Bearbeiten'"
                        [icon]="editDefault ? 'fa-regular fa-eye' : 'fa-regular fa-pen'"
                        severity="secondary"
                        [text]="true"
                        (onClick)="toggleEditDefault()">
                </p-button>
            </div>
            @if (!editDefault && defaultDataWidget) {
                <mvs-widget [widgetData]="defaultDataWidget"></mvs-widget>
            }
            @if (editDefault && defaultEditWidget) {
                <mvs-widget [widgetData]="defaultEditWidget"></mvs-widget>
            }
        </div>

        <!--
          Vorbelegungs-Vorschau: rendert das alias-keyed fieldValuesJson lesbar (Muster: die
          Antragstemplate-Vorschau der Config-Page). Die Schlüssel sind bewusst die rohen
          cc.FieldType-Aliase — der Alias IST der Vertrag (Apply + SMART-Seed).
        -->
        <div>
            <span class="text-lg font-medium block mb-2">
                <i class="fa-regular fa-file-import mr-2"></i>Feldwerte der Vorbelegung
            </span>

            <div class="cw-default-field-values surface-card border-round p-3">

                @if (fieldValuesInvalid) {
                    <div class="text-orange-700 p-2">
                        <i class="fa-regular fa-triangle-exclamation mr-2"></i>Die hinterlegten Feldwerte sind
                        kein gültiges JSON-Objekt und werden beim Anwenden ignoriert.
                    </div>
                } @else if (fieldValueRows.length > 0) {
                    <div class="cw-default-field-values-grid">
                        @for (row of fieldValueRows; track row.alias) {
                            <div class="cw-default-field-values-row">
                                <span class="cw-default-field-values-label text-color-secondary">{{ row.alias }}</span>
                                <span class="cw-default-field-values-value font-medium">{{ row.value }}</span>
                            </div>
                        }
                    </div>
                } @else {
                    <div class="text-color-secondary p-2">
                        Keine Feldwerte hinterlegt
                    </div>
                }

            </div>
        </div>

        <!-- Kind-Zeilen: Bausteine der Vorbelegung -->
        <div>
            <span class="text-lg font-medium block mb-2">Bausteine der Vorbelegung</span>
            @if (coverageValueWidget) {
                <mvs-widget [widgetData]="coverageValueWidget"></mvs-widget>
            }
        </div>

    </div>
}
